import {
  listWaterDeposits,
  detailWaterDeposits,
  listWaterIntakes,
  detailWaterIntakes,
  listApprovedSites,
  detailApprovedSites
} from "../../api/geology";

export default {
  fetchAllWaterDeposits({ commit }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      listWaterDeposits(a)
        .then(res => {
          if (a.is_paginated) commit("SET_WATER_DEPOSITS_TABLE", res.data);
          if (!a.is_paginated) commit("SET_WATER_DEPOSITS_MAP", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchDetailWaterDeposits({ commit }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      detailWaterDeposits(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllWaterIntakes({ commit }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      listWaterIntakes(a)
        .then(res => {
          if (a.is_paginated) commit("SET_WATER_INTAKES_TABLE", res.data);
          if (!a.is_paginated) commit("SET_WATER_INTAKES_MAP", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchDetailWaterIntakes({ commit }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      detailWaterIntakes(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllApprovedSites({ commit }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      listApprovedSites(a)
        .then(res => {
          if (a.is_paginated) commit("SET_APPROVED_SITES_TABLE", res.data);
          if (!a.is_paginated) commit("SET_APPROVED_SITES_MAP", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchDetailApprovedSites({ commit }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      detailApprovedSites(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
